import React from "react";
import { connect } from "react-redux";
import SwipeableViews from "react-swipeable-views";
import { Button, Popup, TextArea } from "devextreme-react";
import DataGrid, { Column } from "devextreme-react/ui/data-grid";
import LoadingGif from "../../../../images/animacion2[18].gif";
import TableFilter from "../../../Shared/tableFilter.jsx";
import { filterData, filterType } from "../../../../helpers/filterHelper";
import {
  openCloseModalAgendar,
  showInfoGestionSolicitud,
  loadDataSelected,
  setWorkerSelected,
  loadDataGrid,
  setTipoSolicitud,
  updateDataGestionar,
  setCleanInbox,
  setSolicitudesEmpresaFiltrada,
  setSelectedSolicitud,
  loadNewDataSelected,
  //loadDataSelectedShow
} from "./actions";
import NuevaGestionSolicitudes from "./Componentes/nuevaGestionSolicitudes";
import ModalVer from "../../../Shared/ModalVer"
import { formatDateForFilter } from "../../../../helpers/dateFormat";
import LoadingOverlay from "../../../Shared/LoadingOverlay";
import validaciones from "../../../../helpers/validaciones";
import UserInfoColumn from "../../../Shared/UserInfoColumn";
// import * as signalR from '@aspnet/signalr';
import apiConfig from "../../../../config/api";
import Moment from "moment";
import config from "../../../../config/api";
import { push } from "connected-react-router";
import { checkAccess, ids, realCheckAccess } from "../../../../helpers/rolAccess";
import { paths } from "../../../../config/routes";

class TableInboxSolicitudes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filtersLoaded: false,
      rejectModal: false,
      textArea: "",
      disabledButtonAgendar: true,
      index: 0,
      connectionHub: null,
      openModalVer: false,
      dataModalVer: null
    };
    this.mainFilter = (_obj) => {
      const _arr = [
        {
          Icon: "2", name: "Pendiente de agendamiento", column: "estadoSolicitud", value: { text: "aprobado", value: [2, 5, 10] },
        },
        {
          Icon: "6", name: "Rechazadas por ejecutivo", column: "estadoSolicitud", value: { text: "rechazado", value: 9 },
        },
        {
          Icon: "b", name: "Agendadas", column: "estadoSolicitud", value: { text: "agendado", value: 4 },
        },

      ];
      if (_obj) { return _arr.find((e) => e.value.text === _obj.value.text); }
      return _arr;
    };
  }

  componentDidMount = (prevProps) => {
    // From: 1 año hacia atras
    // to: año actual.
    const data = {
      from: formatDateForFilter(Moment().subtract(1, "year")),
      to: formatDateForFilter(Moment()),
      companyRut: this.props.companyId,
      PetitionerRut: this.props.userData.RUT,
      StatusId: this.props.selectedTipoSolicitud.value.value,
    };
    this.props.dispatch(loadDataGrid(data));
  }

  componentWillUnmount = () => {
    this.props.dispatch(setCleanInbox());
  }

  componentDidUpdate = (prev) => {
    if(this.props.selectedSolicitudShow && prev.selectedSolicitudShow !== this.props.selectedSolicitudShow){
      this.handleModalVer()
    }
    if (prev.companyId !== this.props.companyId) {
      this.props.dispatch(push(paths.root))
    }
  }

  handleViewGestionar = (Id) => {
    this.props.dispatch(loadNewDataSelected(Id, true, this.handleSetIndex, this.handleCloseViewGestionar));
    // const protocol = new signalR.JsonHubProtocol();
    // const transport = signalR.HttpTransportType.WebSockets;

    // const options = {
    //   transport,
    //   logMessageContent: true,
    //   logger: signalR.LogLevel.Trace,
    //   accessTokenFactory: () => null,
    // };

    // const _connectionHub = new signalR.HubConnectionBuilder()
    // .withUrl(`${apiConfig.apiUri  }signalSaveWorkerScheduling`, options)
    // //.withUrl(config.WebSocketUrl, options)
    // .withHubProtocol(protocol)
    // .configureLogging((logging) => {
    //   logging.AddConsole();
    //   logging.AddDebug();
    // })
    // .build();

    // const _connectionHub = new signalR.HubConnectionBuilder()
    //     .withUrl(config.WebSocketUrl, { accessTokenFactory: () => this.props.tokenJwt })
    //     .configureLogging(signalR.LogLevel.Information)
    //     .build();

    // _connectionHub.start()
    // .then(() => {
    //   this.setState({conectionStarted: true, connectionHub: _connectionHub})
    // })
    // .catch((err) => {
    //   console.error('SignalR Connection 2 Error: ', err);
    // });
  }

  handleSetIndex = (n) => {
    this.setState({index: n})
  }

  handleCloseViewGestionar = async() => {
    this.props.dispatch(setSelectedSolicitud({}));
    this.setState({index: 0})
    if(this.state.connectionHub){
      this.state.connectionHub.stop()
    }
  }

  handleCloseGestionarsolicitud = () => {
    this.props.dispatch(showInfoGestionSolicitud(false));
    this.setState({ disabledButtonAgendar: true, index: 0 });
  }

  renderInfoBoxEnterprise = () => {
    const {
      CompanyName,
      CompanyRut,
      RequestTypeDescription,
      ProposalDate,
      ProposalDateEnd,
      PetitionerName,
      PetitionerRut,
      Pools,
      WorkersQuota,
      CostCenter,
      AdditionalExams,
      PsychologicalExams,
      Workers,
    } = this.props.selectedSolicitud;
    const _isAnyScheduling = Workers.find((e) => e.IsScheduling === true);
    return (
      <div>
        <div className="row infoEnterpriseBox">
          <div className="col-12">
            <div className="row">
              <div className="col-1 zero">
                <Button
                  icon="arrowleft"
                  type="success"
                  text="Volver"
                  onClick={() => this.handleCloseGestionarsolicitud()}
                />
              </div>
              <div className="col-1">
                Empresa solicitante:
              </div>
              <div className="col-2">
                <UserInfoColumn
                  nombre={CompanyName}
                  rut={CompanyRut}
                />
              </div>
              <div className="col-1">
                Tipo Evaluación:
              </div>
              <div className="col-2">
                {RequestTypeDescription}
              </div>
              <div className="col-1">
                Fecha Preferente:
              </div>
              <div className="col-2">
                {
                  (ProposalDate ? Moment(ProposalDate).format("DD/MM/YYYY") : "")
                  + (ProposalDateEnd ? ` - ${Moment(ProposalDateEnd).format("DD/MM/YYYY")}` : "")}
              </div>
            </div>
            <div className="row">
              <div className="col-1 zero">
                {!_isAnyScheduling &&
                  <Button
                    onClick={() => this.setState({ rejectModal: true })}
                    type="danger"
                    text="Rechazar"
                  />
                }
              </div>
              <div className="col-1">
                Solicitante:
              </div>
              <div className="col-2">
                <UserInfoColumn
                  nombre={PetitionerName}
                  rut={PetitionerRut}
                />
              </div>
              <div className="col-1">
                Centro de costos:
              </div>
              <div className="col-2">
                {CostCenter}
              </div>
              <div className="col-1">
                Trabajadores:
              </div>
              <div className="col-1">
                {WorkersQuota || "0"}
              </div>
            </div>
            <div className="row">
              <div className="col-1 zero">
                {(!_isAnyScheduling && this.state.disabledButtonAgendar === true) &&
                  <Button
                    onClick={() => this.setState({ disabledButtonAgendar: false })}
                    type="success"
                    text="Agendar"
                  />
                }
              </div>
              <div className="col-1">
                Baterías:
              </div>
              <div className="col-2">
                {Pools.map((e, i) => <span key={`exams_1_${i}`} className="span_exams">{e.Description}{e.AchsOfficeDescription ? `(${e.AchsOfficeDescription})` : ""}</span>)}
              </div>
              <div className="col-1">
                Prestaciones médicas:
              </div>

              <div className="col-2">
                {AdditionalExams ?
                  AdditionalExams.map((e, i) => <span key={`exams_2_${i}`} className="span_exams">{e.ExamDescription}{e.AchsOfficeDescription ? `(${e.AchsOfficeDescription})` : ""}</span>)
                  : ""
                }
              </div>
              <div className="col-1">
                Evaluaciones  psicológicas:
              </div>
              <div className="col-2">
                {PsychologicalExams ?
                  PsychologicalExams.map((e, i) => <span key={`exams_3_${i}`} className="span_exams">{e.ExamDescription}{e.AchsOfficeDescription ? `(${e.AchsOfficeDescription})` : ""}</span>)
                  : ""
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderTrabajadoresDataGrid() {
    const { selectedSolicitud } = this.props;
    const _isAnyScheduling = (selectedSolicitud && selectedSolicitud.Workers) && selectedSolicitud.Workers.find((e) => e.IsScheduling === true);
    return (
      <div>
        <DataGrid
          dataSource={selectedSolicitud && selectedSolicitud.Workers}
          onRowPrepared={this.heightRow}
          showBorders={false}
          showColumnLines={false}
          showRowLines={false}
          noDataText=""
          className="custom-table"
          rowAlternationEnabled
          hoverStateEnabled={false}
          activeStateEnabled={false}
          focusStateEnabled={false}
          onContentReady={(e) => {
            if (e.component.totalCount() === 0) {
              const config = {};
              config.addClass = "table-margin";
              const noDataSpan = e.component.element().querySelector(".dx-datagrid-nodata");
              const element = validaciones.noDataDOMElement(config, "Sin solicitudes");
              noDataSpan && noDataSpan.appendChild(element);
            }
          }}
          loadPanel={{
            enabled: true,
            showPane: true,
            showIndicator: true,
            indicatorSrc: LoadingGif,
            text: "Cargando...",
          }}
          paging={{
            pageSize: 5,
          }}
          pager={{
            showInfo: true,
            visible: true,
            infoText: (page, total, items) => `Página ${page} de ${total} (${items} resultados)`,
          }}
        >
          <Column
            caption="Nombre"
            allowSearch
            alignment="center"
            cellComponent={(props) => (
              <div>
                {props.data.Name ? props.data.Name
                  :
                <div>Sin Nombre</div>}
              </div>
            )}
          />
          <Column
            caption="Número de documento"
            allowSearch
            alignment="center"
            cellComponent={(props) => (
              <div>
                {props.data.DocumentNumber ? props.data.DocumentNumber
                  :
                <div></div>}
              </div>
            )}
          />
          <Column
            caption="Teléfono"
            allowSearch
            alignment="center"
            dataField="Phone"
          />
          <Column
            caption="Correo"
            allowSearch
            alignment="center"
            dataField="Mail"
          />
          <Column
            caption="Agendamiento"
            alignment="center"
            cellComponent={(props) => (
              <div>
                {!props.data.IsScheduling ? <Button
                  text="Agendar"
                  type="success"
                  className="slimButton"
                  disabled={
                    !_isAnyScheduling && this.state.disabledButtonAgendar === true ?
                      true
                      : !_isAnyScheduling && this.state.disabledButtonAgendar === false ?
                        false
                        : !_isAnyScheduling
                  }
                  onClick={() => this.handleWorkerModal(props)}
                />
                  :
                <div>Agendado</div>}
              </div>
            )}
          />
        </DataGrid>
      </div>
    );
  }

  handleWorkerModal(data) {
    this.props.dispatch(setWorkerSelected(data.data.Id));
    this.props.dispatch(openCloseModalAgendar(true));
  }

  doGetComplains = (data) => {
    const filtros = {
      from: formatDateForFilter(Moment().subtract(1, "year")),
      to: formatDateForFilter(Moment()),
      companyRut: this.props.companyId,
      PetitionerRut: this.props.userData.RUT,
      StatusId: this.props.selectedTipoSolicitud.value.value,
    };
    if (validaciones.emptyText(this.props.sucursalId)) {
      filtros.idSucursal = this.props.sucursalId;
    }
    this.props.dispatch(loadDataGrid(filtros));
  }

  handleFilterChange = (text, filters) => {
    let currentFilters = [...filters];
    const _estadoSolicitud = currentFilters.find((e) => e.column === "estadoSolicitud");
    if (_estadoSolicitud && this.props.selectedTipoSolicitud.value.value !== _estadoSolicitud.value.value) {
      this.props.dispatch(setTipoSolicitud(this.mainFilter(_estadoSolicitud)));
      this.doGetComplains();
    } else {
      currentFilters = currentFilters.map((e) => e.column !== "estadoSolicitud" ? e : null).filter((e) => e);
      if (text) {
        currentFilters.push({
          column: "Id", filterValue: null, value: { text, value: text }, type: filterType.search,
        });
      }
      const ProposalDate = currentFilters.length > 0 ? currentFilters.filter((f) => f.column === "ProposalDate") : [];
      if (ProposalDate.length > 0) {
        const pivotFecha = ProposalDate.find((i) => i.column === "ProposalDate");
        let FechaDesde = null;

        if (this.state.doFilterProposalDate === true) {
          FechaDesde = this.state.ProposalDate;
        } else {
          FechaDesde = formatDateForFilter(Moment().subtract(1, "year"));
        }
        const dateIsBefore = Moment(pivotFecha.value.value.from).isBefore(Moment(FechaDesde));
        // llamado al api cuando las fechas son menores con respecto a las que mando por primera vez
        if (dateIsBefore === true) {
          const data = {
            from: formatDateForFilter(Moment(pivotFecha.value.value.from)),
            to: formatDateForFilter(Moment(pivotFecha.value.value.to)),
          };
          this.doGetComplains(data);
          this.setState({
            doFilterProposalDate: true,
            ProposalDate: pivotFecha.value.value.from,
          });
        }
      }
      if (this.state.doFilterProposalDate && ProposalDate.length === 0) {
        // vuelvo a la carga de datos inicial. al limpiar el rango de fecha que fue menor a la orginal
        const data = {
          from: formatDateForFilter(Moment().subtract(1, "year")),
          to: formatDateForFilter(Moment()),
        };
        this.doGetComplains(data);
        this.setState({
          doFilterProposalDate: false,
          ProposalDate: null,
        });
      }
      const newData = filterData(this.props.listaSolicitudes, currentFilters);
      if (currentFilters.length > 0) {
        this.props.dispatch(setSolicitudesEmpresaFiltrada(newData));
      } else {
        this.props.dispatch(setSolicitudesEmpresaFiltrada(this.props.listaSolicitudes));
      }
    }
  }

  renderSolicitudesDataGrid() {
    const {
      selectedTipoSolicitud,
    } = this.props;
    const textStatus = selectedTipoSolicitud.value && selectedTipoSolicitud.value.text ? selectedTipoSolicitud.value.text : null;
    const { listaSolicitudesFiltrada } = this.props;
    const columns = () => {
      const _columns = [];
      _columns.push(
        {
          caption: "N° de Solicitud",
          allowSearch: true,
          alignment: "center",
        },
        {
          caption: "Empresa",
          allowSearch: true,
          alignment: "left",
        },
        {
          caption: "Aprobador",
          allowSearch: true,
          alignment: "left",
        }
      );
      if (textStatus !== "rechazado") {
        _columns.push(
          {
            caption: "Fecha de cita deseada",
            allowSearch: true,
            alignment: "center",
            dataType: "date",
            format: "dd/MM/yyyy",
          },
          {
            caption: "Cantidad de trabajadores",
            allowSearch: true,
            alignment: "center",
          }
        );
      }
      if (textStatus === "rechazado") {
        _columns.push(
          {
            caption: "Fecha de rechazo",
            allowSearch: true,
            alignment: "center",
            dataType: "date",
            format: "dd/MM/yyyy",
          },
          {
            caption: "Cantidad de trabajadores",
            allowSearch: true,
            alignment: "center",
          },
          {
            caption: "Tipo de evaluación",
            allowSearch: true,
            alignment: "center",
          },
          {
            caption: "Baterías/Prestaciones",
            allowSearch: true,
            alignment: "center",
          }
        );
      }
      if (textStatus !== "rechazado" && textStatus !== "agendado") {
        _columns.push(
          {
            caption: "Fecha de aprobación",
            allowSearch: true,
            alignment: "center",
            dataType: "date",
            format: "dd/MM/yyyy",
          }
        );
      }

      if (textStatus === "agendado") {
        _columns.push(
          {
            caption: "Fecha de aprobación",
            allowSearch: true,
            alignment: "center",
            dataType: "date",
            format: "dd/MM/yyyy",
          },
        );
      }
      _columns.push({
        caption: "",
        allowSearch: true,
        alignment: "center",
      })
      return _columns;
    };
    const DataRow = (rowInfo) => {
      const _data = rowInfo.data ? rowInfo.data : null;
      return (<tbody className="dx-row">
        {textStatus === "rechazado" ?
          <React.Fragment>
            <tr className="main-row">
              <td style={{ textAlign: "center" }}>{_data.Id}</td>
              <td>
                <UserInfoColumn
                  nombre={_data.CompanyName}
                  rut={_data.CompanyRut}
                />
              </td>
              <td>
                <UserInfoColumn
                  nombre={_data.AuthorizedName}
                  rut={_data.AuthorizedRut}
                />
              </td>
              <td style={{ textAlign: "center" }}>{_data.RejectCallCenterDate && Moment(_data.RejectCallCenterDate).format("L")}</td>
              <td style={{ textAlign: "center" }}>{_data.WorkersQuota}</td>
              <td style={{ textAlign: "center" }}>{_data.RequestTypeDescription}</td>
              <td style={{ textAlign: "center" }}>{_data.Pools}</td>
              <td style={{ textAlign: "center" }}>
                <Button
                  text="Ver"
                  type="success"
                  className="slimButton"
                  //disabled={(_data.StatusId === 10)}
                  onClick={() => this.openModalVer(_data)}
                />
              </td>
            </tr>
            <tr className="notes-row">
              <td colSpan="4">
                <div className="row">
                  <div className="col-2" style={{ fontWeight: "bold" }}>Comentario:</div>
                  <div className="col-10">{_data.RejectComment}</div>
                </div>
              </td>
            </tr>
          </React.Fragment>
        :
          <React.Fragment>
            <tr className="main-row">
              <td style={{ textAlign: "center" }}>{_data.Id}</td>
              <td>
                <UserInfoColumn
                  nombre={_data.CompanyName}
                  rut={_data.CompanyRut}
                />
              </td>
              <td>
                <UserInfoColumn
                  nombre={_data.AuthorizedName}
                  rut={_data.AuthorizedRut}
                />
              </td>
              <React.Fragment>
                <td style={{ textAlign: "center" }}>{_data.ProposalDate && Moment(_data.ProposalDate).format("L") }</td>
                <td style={{ textAlign: "center" }}>{_data.WorkersQuota}</td>
                <td style={{ textAlign: "center" }}>{_data.ApprovalDate && Moment(_data.ApprovalDate).format("L") }</td>

                {textStatus !== "agendado" && <td style={{ textAlign: "center" }}>
                  <Button
                    text="Gestionar"
                    type="success"
                    className="slimButton"
                    //disabled={(_data.StatusId === 10)}
                    onClick={() => this.handleViewGestionar(_data.Id)}
                  />
                </td>  }
              </React.Fragment>
            </tr>
          </React.Fragment>
        }

      </tbody>);
    };
    return (
      <div>
        <div className="col-12">
          <DataGrid
            dataSource={listaSolicitudesFiltrada}
            onRowPrepared={this.heightRow}
            showBorders={false}
            showColumnLines={false}
            showRowLines={false}
            noDataText=""
            className="custom-table agendamiento"
            rowAlternationEnabled
            hoverStateEnabled={false}
            activeStateEnabled={false}
            focusStateEnabled={false}
            onContentReady={(e) => {
              if (e.component.totalCount() === 0) {
                const config = {};
                config.addClass = "table-margin";
                const noDataSpan = e.component.element().querySelector(".dx-datagrid-nodata");
                const element = validaciones.noDataDOMElement(config, "Sin solicitudes");
                noDataSpan.appendChild(element);
              }
            }}

            loadPanel={{
              enabled: false,
              showPane: true,
              showIndicator: true,
              indicatorSrc: LoadingGif,
              text: "Cargando...",
            }}
            paging={{
              pageSize: 20,
            }}
            pager={{
              showInfo: true,
              visible: true,
              infoText: (page, total, items) => `Página ${page} de ${total} (${items} resultados)`,
            }}
            columns={columns()}
            rowComponent={DataRow}
          />
        </div>
      </div>
    );
  }

  rejectSolicitud = async () => {
    const _data = {
      RequestId: this.props.selectedSolicitud && this.props.selectedSolicitud.Id ? this.props.selectedSolicitud.Id : 0,
      RequestStatus: 9,
      Comment: this.state.textArea,
    };
    await this.props.dispatch(updateDataGestionar(_data));
    this.doGetComplains();
    this.setState({ rejectModal: false, textArea: "" });
  }

  handleModalVer = () => {
    const {
      Pools,
      AdditionalExams,
      PsychologicalExams,
      Workers,
      CompanyName,
      CostCenter,
      PetitionerName,
      PetitionerRut,
      ProposalDate,
      ProposalDateEnd,
      WorkersQuota,
      RequestTypeDescription,
      defaultCityDescription
    } = this.props.selectedSolicitudShow;
    let _data = {};
    const _firstBenefit = [...Pools,...AdditionalExams,...PsychologicalExams].find(e => e.AchsOfficeDescription);
    _data.defaultCityDescription = _firstBenefit && _firstBenefit.AchsOfficeDescription ? _firstBenefit.AchsOfficeDescription : "";
    const baterias = Pools ? [{ key: `Baterías (${Pools.length})`, items: Pools.map((e) => e.Description) }] : [];
    const examenes = AdditionalExams ? [{ key: `Prestaciones médicas (${AdditionalExams.length})`, items: AdditionalExams.map((e) => e.ExamDescription) }] : [];
    const psicologicos = PsychologicalExams ? [{ key: `Evaluaciones psicológicas (${PsychologicalExams.length})`, items: PsychologicalExams.map((e) => e.ExamDescription) }] : [];
    _data.benefits = [...baterias, ...examenes, ...psicologicos];
    _data.workers = Workers ? Workers : [];
    _data.info = {
      CompanyName: CompanyName ? CompanyName : "",
      CostCenter: CostCenter ? CostCenter : "",
      PetitionerName: PetitionerName ? PetitionerName : "",
      PetitionerRut: PetitionerRut ? PetitionerRut : "",
      ProposalDate: ProposalDate ? ProposalDate : "",
      ProposalDateEnd: ProposalDateEnd ? ProposalDateEnd : "",
      WorkersQuota: WorkersQuota ? WorkersQuota : "",
      RequestTypeDescription: RequestTypeDescription ? RequestTypeDescription : "",
      defaultCityDescription: defaultCityDescription ? defaultCityDescription : ""
    }
    this.setState({openModalVer: true, dataModalVer: _data})
  }

  openModalVer = (row) => {
    this.props.dispatch(loadDataSelected(row.Id, true));
  }

  closeModalVer = () => {
    this.setState({openModalVer: false, dataModalVer: null})
  }

  render() {
    const { filtrosSolicitudes } = this.props;
    const {
      selectedTipoSolicitud,
    } = this.props;
    let newFiltros;
    const textStatus = selectedTipoSolicitud.value && selectedTipoSolicitud.value.text ? selectedTipoSolicitud.value.text : null;
    if (textStatus !== "rechazado") {
      newFiltros = filtrosSolicitudes ? filtrosSolicitudes.filter((x) => x.column !== "RejectCallCenterDate") : null;
    } else if (textStatus !== "aprobado") {
      newFiltros = filtrosSolicitudes ? filtrosSolicitudes.filter((x) => x.column !== "ApprovalDate") : null;
    }
    return (
      <div>
        {this.props.isLoading && <LoadingOverlay />}
        <ModalVer
          data={this.state.dataModalVer}
          isOpen={this.state.openModalVer}
          close={this.closeModalVer}
        />
        <SwipeableViews
          index={this.state.index}
          disabled
          async
        >
          <div>
            <div className="table-wrapper">
              {this.props.gestionarSolicitudStatus === false && <div>
                <div className="col-12">
                  <TableFilter
                    placeholder="Buscar solicitud"
                    onChange={this.handleFilterChange}
                    filters={newFiltros}
                    show
                    buttons={
                      {
                        filter: { buttonName: "iconFilter", visible: true, buttonAction: null },
                        document: null,
                        download: { buttonName: "iconDownload", visible: false, buttonAction: null },
                        newItem: null,
                      }
                    }
                    selectedMainFilter={this.props.selectedTipoSolicitud}
                    mainFilter={this.mainFilter()}
                  />
                </div>
              </div>}
              {this.renderSolicitudesDataGrid()}
            </div>
          </div>
          <div className={"nuevaGestionSolicitud"} style={{height: "100%"}}>
            {this.props.selectedSolicitud && this.props.selectedSolicitud.Id &&
              <NuevaGestionSolicitudes
                connectionHub={this.state.connectionHub}
                close={this.handleCloseViewGestionar}
              />
            }
          </div>
        </SwipeableViews>
      </div>
    );
  }
}


const mapStateToProps = (state) => ({
  isLoading: state.inboxSolicitudes.isLoading,
  listaSolicitudes: state.inboxSolicitudes.listaSolicitudes,
  listaSolicitudesFiltrada: state.inboxSolicitudes.listaSolicitudesFiltrada,
  filtrosSolicitudes: state.inboxSolicitudes.filtrosSolicitudes,
  companyId: state.global.companyId,
  sucursalId: state.global.sucursalId,
  userData: state.global.userData,
  gestionarSolicitudStatus: state.inboxSolicitudes.gestionarSolicitudStatus,
  selectedSolicitud: state.inboxSolicitudes.selectedSolicitud,
  dataSelected: state.inboxSolicitudes.dataSelected,
  selectedTipoSolicitud: state.inboxSolicitudes.selectedTipoSolicitud,
  tokenJwt: state.headerNotificaciones.tokenJwt,
  selectedSolicitudShow: state.inboxSolicitudes.selectedSolicitudShow,
  userAccessIds: state.global.userAccessIds,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(TableInboxSolicitudes);
